if (!customElements.get('logo-tabs')) {
  customElements.define('logo-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-tab]');
        if (!button || !this.contains(button)) return;
        this.querySelectorAll('[data-tab]').forEach((tab) => {
          const active = tab === button;
          tab.classList.toggle('active', active);
          tab.setAttribute('aria-pressed', String(active));
        });
        this.querySelectorAll('[data-logo-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.logoPanel !== button.dataset.tab;
        });
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
